<template>
  <div>
    <lightbox v-if="media" :href="media | media('original')" :title="media && (media.description || media.name)" :group="group">
      <template v-if="thumbnail">
        <div class="image-thumbnail img-rounded empty-thumbnail" :class="{'no-image': !isImage(media)}">
          <div>
            <i class="icon-file-empty position-left"></i>
            <span>{{getExtension(media)}}</span>
          </div>
        </div>
        <img v-if="isImage(media)" :src="media | media('admin-thumbnail')" width="95" height="70" :alt="media.alt || media.name" class="img-thumbnail img-rounded">
      </template>
      <template v-if="preview">
        <img v-if="isImage(media)" :src="media | media('admin-preview')" width="640" :alt="media.alt || media.name" class="img-thumbnail img-rounded">
        <span v-else>
          <i class="icon-file-empty position-left"></i>
          <strong>{{media.name}}</strong>
        </span>
      </template>
    </lightbox>
    <span class="text-muted" v-else v-text="emptyLabel"></span>
  </div>
</template>

<style type="text/css" lang="css" scoped>
  .empty-thumbnail {
    background: #fff;
    color: #999;
    display: table;
    height: 70px;
    margin: 0 -95px -70px 0;
    position: relative;
    text-align: center;
    z-index: 1;
    width: 95px;
  }
  .empty-thumbnail.no-image {
    margin-bottom: 0;
    position: static;
  }

  .empty-thumbnail > div {
    display: table-cell;
    vertical-align: middle;
  }
  .empty-thumbnail.no-image > div {
    border: 1px solid #ddd;
    border-radius: 3px;
    padding: 3px;
  }

  .empty-thumbnail + img {
    background: none;
    position: relative;
    z-index: 2;
  }
</style>

<script>
  const extMatch = /^[^\.]*(\.[^\.]*)*\.(\w{1,6})$/;

  export default {
    components: {
      Lightbox: () => import('package-common-vuejs/src/components/Lightbox'),
    },
    props: {
      media: Object,
      thumbnail: Boolean,
      preview: Boolean,
      group: String,
      emptyLabel: {type: String, default: 'Aucun fichier'},
    },
    methods: {
      getExtension({name, mime}) {
        return (name.match(extMatch) && name.replace(extMatch, '$2')) || mime.replace(/^(.*\/)/, '');
      },
      isImage({mime}) {
       return mime && mime.match(/^image\//);
      },
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/MediaImage.vue